export const EVENT_TYPES_QUERY_KEY = 'eventTypes' as const;

export const eventTypesKeys = {
  all: () => [EVENT_TYPES_QUERY_KEY] as const,
  calibrationTypes: () => [EVENT_TYPES_QUERY_KEY, 'calibration'] as const
} as const;
